(() => {
  const configNode = document.getElementById('bfd-flash-sale-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const params = new URLSearchParams(location.search);
  const preview = params.get('bfd_preview') === '1' && String(window.Shopify?.theme?.id) === config.themeId && window.Shopify?.theme?.role === 'unpublished';
  let serverBase = 0;
  let syncAt = 0;
  let uncertainty = 0;
  let synced = false;
  let currentState = null;
  let busy = false;
  let expiryTimer = null;
  const putText = (el,text) => { if (el.textContent !== text) el.textContent = text; };
  const render = () => {
    const elapsed = performance.now() - syncAt;
    const lower = serverBase + elapsed;
    const upper = lower + uncertainty;
    const released = config.enabled === true && config.end > config.start;
    const fresh = synced && elapsed < 90000;
    const active = preview || (released && fresh && lower >= config.start && upper < config.end);
    if (expiryTimer !== null) clearTimeout(expiryTimer);
    if (active && !preview) expiryTimer = setTimeout(render,Math.max(1,Math.min(config.end - upper,2147483647)));
    const ended = !preview && released && fresh && upper >= config.end;
    document.querySelectorAll('[data-bfd-active]').forEach(el => { el.hidden = !active; });
    document.querySelectorAll('[data-bfd-inactive],[data-bfd-price-native]').forEach(el => { el.hidden = active; });
    document.querySelectorAll('[id$="' + config.defaultHeroSuffix + '"]').forEach(el => { el.hidden = active; });
    document.querySelectorAll('[data-bfd-status-heading]').forEach(el => { putText(el, ended ? config.messages.endedHeading : config.messages.inactiveHeading); });
    document.querySelectorAll('[data-bfd-status-description]').forEach(el => { putText(el, ended ? config.messages.endedNote : config.messages.inactiveNote); });
    if (active) {
      const deadline = config.end > config.start ? config.messages.ends + ' ' + new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York',weekday: 'short',month: 'short',day: 'numeric',hour: 'numeric',minute: '2-digit',timeZoneName: 'short'}).format(new Date(config.end - 1000)) + ' · ' + config.messages.stockNote : 'Preview · Final sale end time pending';
      document.querySelectorAll('[data-bfd-deadline]').forEach(el => { putText(el,deadline); });
    }
    if (currentState !== active) {
      currentState = active;
      document.dispatchEvent(new CustomEvent('bfd:sale-state', {detail:{active,ended,preview}}));
    }
  };
  const sync = async () => {
    if (busy || preview || config.enabled !== true || config.end <= config.start) return;
    busy = true;
    const requestedAt = performance.now();
    try {
      const response = await fetch('/?bfd_server_time=' + crypto.randomUUID(), {method:'HEAD',cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(5000)});
      const date = Date.parse(response.headers.get('date') || '');
      if (!response.ok || !Number.isFinite(date)) throw new Error('Server time unavailable');
      syncAt = performance.now();
      serverBase = date;
      uncertainty = 1000 + (syncAt - requestedAt);
      synced = true;
    } catch {
      synced = false;
    } finally {
      busy = false;
      render();
    }
  };
  if (preview) {
    const note = document.createElement('div');
    note.className = 'bfd-sale-preview-note';
    note.textContent = 'Unpublished sale preview · Checkout discounts are not active';
    document.body.prepend(note);
  }
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) render();
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',() => { if (!document.hidden) { render(); sync(); } });
  window.addEventListener('pageshow',() => { render(); sync(); });
  render();
  sync();
  setInterval(render,1000);
  setInterval(sync,30000);
})();
